module.exports = __webpack_public_path__ + "img/events-2.31941377.jpg";